import React from "react";
import { Typography, Link } from "@mui/material";
import PageShell from "../components/PageShell";
import PageTitle from "../components/PageTitle";

export default function Terms() {
  return (
    <PageShell>
      <PageTitle>Terms of Service</PageTitle>
      <Typography variant="body1" sx={{ mb: 2 }}>
        By using this site, you agree to the following:
      </Typography>
      <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
        {`• Lawful use only; no abuse, scraping, or DDoS.\n• Plans/quotas may change with reasonable notice.\n• Payments handled via Stripe; refunds per Stripe policy.\n• Service provided “as is”, without warranties.`}
      </Typography>
      <Typography variant="body2" sx={{ mt: 3 }}>
        Contact: <Link href="mailto:info@mtinnotech.org">info@mtinnotech.org</Link>
      </Typography>
    </PageShell>
  );
}
